module.exports = __webpack_public_path__ + "front/img/27_8.46ce66b4.png";